import type { AuthenticatedUserPayload } from '@Application/Security/Authentications/Actions/userAuthenticated';

export type SecondFactorVerifiedPayload = {
	readonly user: AuthenticatedUserPayload;
	readonly remainingRecoveryCodes: number;
};

export type SecondFactorVerifiedAction = {
	type: 'SECOND_FACTOR_VERIFIED';
	payload: SecondFactorVerifiedPayload;
};

export default (payload: SecondFactorVerifiedPayload): SecondFactorVerifiedAction => ({
	type: 'SECOND_FACTOR_VERIFIED',
	payload,
});
